module.exports = __webpack_public_path__ + "static/media/contact_03.e88db53c.jpg";